import React from 'react';
import SettingSwitch from '@molecules/SettingSwitch';
import SettingBlock from '@components/Presentation/main/Settings/units/SettingBlock';

const TextArea = ({
  options,
  setOptions,
  disabled,
  featureType
}) => {
  return (
    <div className="w-full">
      <textarea
        disabled={disabled}
        className={`w-full h-31 p-2 rounded-md border border-grey-400 dark:border-grey-700 dark:bg-transparent resize-none 
          focus:outline-blue-500 whitespace-pre-line ${disabled ? 'opacity-50' : ''}`}
        placeholder={featureType === 'wheel' ? 'Entry 1\nEntry 2\nEntry 3' : 'Name 1\nName 2\nName 3'}
        value={options.map((option) => option.body).join('\n')}
        onChange={(e) => setOptions(e.target.value.split('\n').map((body) => ({ body })))}
      />
    </div>
  );
};

const ChoiceCircleOptions = ({
  options,
  setOptions,
  setting = {},
  featureType = 'wheel',
  updateSetting = () => {},
  disabled = false
}) => {
  return (
    featureType === 'wheel' ?
      <>
        <span className="block mt-4"></span>
        <SettingBlock
          title="Entries"
          tooltip="Add options to be randomly chosen by the spinner wheel."
          titleMargin="sm"
          hasBorderTop={false}
          hasParentBg
        >
          <TextArea options={options} setOptions={setOptions} />
        </SettingBlock>
      </>
      :
      <>
        <SettingSwitch
          label="Names (optional)"
          labelCss="font-semibold"
          tooltipContent="Add participants to be randomly chosen by the winning wheel."
          settingKey="enableWheelOptions"
          settingValue={setting.enableWheelOptions}
          onChangeHandler={(e) => {
            updateSetting('enableWheelOptions', !setting.enableWheelOptions);
          }}
        />
        <TextArea options={options} setOptions={setOptions} disabled={disabled} featureType={featureType} />
      </>
  );
};

export default ChoiceCircleOptions;
